import { render, staticRenderFns } from "./IdleTimeoutWarning.vue?vue&type=template&id=9c960ec2&scoped=true"
import script from "./IdleTimeoutWarning.vue?vue&type=script&lang=ts"
export * from "./IdleTimeoutWarning.vue?vue&type=script&lang=ts"
import style0 from "./IdleTimeoutWarning.vue?vue&type=style&index=0&id=9c960ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c960ec2",
  null
  
)

export default component.exports